export default "/images/layout.svg?4d16993b5d384a25924ff8abf1bdc39d";